export { closeBrowser, openAccountProfile, openChatWindow, openUrlInExternalBrowser } from "./base";
export * from "./notifications";
export * from "./sounds";

import * as supplyNotifications from "./newSupply";
import * as Supply from "./supply";

export const supply = Supply;
export const SupplyNotifications = supplyNotifications;
export const ClanBaseSoundObjectPos = supplyNotifications.ClanBaseSoundObjectPos;
export const ClanBaseCameraPos = supplyNotifications.ClanBaseCameraPos;